import * as React from "react";
import TextField from "@mui/material/TextField";
import { Autocomplete, useTheme } from "@mui/material";
import { STATUS_ORCAMENTO } from "../../constants";
import { useEffect, useState } from "react";

type Props = {
  codigoStatus: number;
  setStatus: (obj: (typeof STATUS_ORCAMENTO)[0]) => void;
  disabled?: boolean;
};

const StatusOrcamentoField: React.FC<Props> = (props) => {
  const { codigoStatus, setStatus, disabled } = props;

  const theme = useTheme();

  const [statusSelecionado, setStatusSelecionado] = useState<
    (typeof STATUS_ORCAMENTO)[0] | null
  >(null);
  const xsValue = theme.breakpoints.down("sm") ? 12 : 6;

  useEffect(() => {
    const status = STATUS_ORCAMENTO.find((item) => item.id === codigoStatus);
    if (status) {
      setStatusSelecionado(status);
    }
  }, [codigoStatus]);

  return (
    <div style={{ textAlign: "center" }}>
      <Autocomplete
        id="filter-status-orcamento"
        options={STATUS_ORCAMENTO}
        getOptionLabel={(option) => option.decricao}
        value={statusSelecionado}
        onChange={(event, value) => {
          if (value) setStatus(value);
        }}
        sx={{ xsValue }}
        renderInput={(params) => (
          <TextField
            {...params}
            disabled={disabled}
            variant={"outlined"}
            label={"Status orçamento"}
            placeholder={"Status orçamento"}
            multiline={true}
          />
        )}
      />
    </div>
  );
};

export default StatusOrcamentoField;
